const Input = ({ placeholder, type, name, register, required = false }) => {
  return (
    <input
      type={type}
      maxLength={50}
      placeholder={placeholder}
      className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
      {...register(name, {
        minLength: 6,
        required: true
      })}
    />
  )
}

export default Input
